import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        //? for debug: console.log('CompleteSurvey', payload);
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            let result = await apiClient(config).apiMethod({
                method: 'CompleteSurvey',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
                args: {},
                urlArgs: {
                    survey_id: payload.survey_id,
                },
            });

            // We will either get back an error code on a failure, or on success - an empty result or a BAR object.
            // a BAR/Bonus will only be returned if we happen to trigger a promotion.
            if (result.code) {
                return {
                    ...result,
                    success: false,
                    isError: true,
                    error: result,
                };
            } else {
                return {
                    ...result,
                    isError: false,
                    error: {},
                    bonus: result,
                };
            }
        } else {
            return {};
        }
    };
};
